import { LightningElement, api, wire } from "lwc";
import { localizeDate } from "@devforce/trailhead-client-locale";
import { LabelsAdapter } from "common/labelsAdapter";
import { hoursMinutesLeftLabel } from "common/labels";

var data$9 = { completed: "Erledigt am %{date}" };
data$9.completed;

var data$8 = { completed: "Completed %{date}" };
data$8.completed;

var data$7 = { completed: "Completado el %{date}" };
data$7.completed;

var data$6 = { completed: "Completado el %{date}" };
data$6.completed;

var data$5 = { completed: "Terminé le %{date}" };
data$5.completed;

var data$4 = { completed: "Completato il %{date}" };
data$4.completed;

var data$3 = { completed: "完了日: %{date}" };
data$3.completed;

var data$2 = { completed: "완료 날짜: %{date}" };
data$2.completed;

var data$1 = { completed: "Concluído a %{date}" };
data$1.completed;

var data = { completed: "%{date} 完成" };
data.completed;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class contentProgress extends LightningElement {
  @api compact = null;
  @api estimatedTimeLeft = null;
  @api finishedAt = null;
  @api progress = null;
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  _labels = null;
  get labels() {
    return {
      ...this._labels,
      completed: this.finishedAt ? this._labels.completed : "",
    };
  }
  get labelOptions() {
    let finishedAtValue = "";
    if (this.finishedAt) {
      if (typeof this.finishedAt === "string") {
        finishedAtValue = localizeDate(this.finishedAt);
      } else if (this.finishedAt.value) {
        finishedAtValue = this.finishedAt.localize
          ? localizeDate(this.finishedAt.value)
          : this.finishedAt.value;
      }
    }
    return {
      completed: {
        date: finishedAtValue,
      },
    };
  }
  get isCompact() {
    return typeof this.compact === "boolean"
      ? this.compact
      : this.compact !== null;
  }
  get valueStyle() {
    return `width: ${this.progress}%`;
  }
  get showComplete() {
    return this.isFinished();
  }
  get showProgress() {
    return this.progress != null && !this.isFinished();
  }
  get showText() {
    return this.progress == null && !this.isFinished();
  }
  get estimatedTimeLeftLabel() {
    if (this.estimatedTimeLeft) {
      return hoursMinutesLeftLabel(this.estimatedTimeLeft);
    }
    return undefined;
  }
  get showEstimatedTimeLeft() {
    return !this.isCompact && this.estimatedTimeLeft;
  }

  /**
   * Will return if the item is finished for any option of
   * finishedAt: null, string, object with or without a value
   */
  isFinished() {
    if (!this.finishedAt) {
      return false;
    }
    return typeof this.finishedAt === "string" || this.finishedAt.value;
  }
}

export default contentProgress;
